<footer
  id="mh-footer"
  class="{colorClassNames.hover}"
  on:click="{logClickEventFooter}"
  aria-label="Footer"
>
  <nav>
    <div class="mh-brand">
      <Brand className="{colorClassNames.primary}" {...brand} />
    </div>

    <div class="mh-top-links">
      <FooterTopLinks {colorClassNames} {topLinkGroups} />
    </div>

    <div class="mh-social-icons">
      <SocialLinks {colorClassNames} links="{socialLinks}" />
    </div>

    <div class="mh-country">
      <Country {colorClassNames} {...country} />
    </div>

    <div class="mh-bottom-links">
      <FooterBottomLinks {colorClassNames} {bottomLinks} />
      <CopyrightNotice {copyrightNotice} />
    </div>

    {#if companyInformation}
    <div class="mh-company-info">
      <CompanyInformation {companyInformation} />
    </div>
    {/if}
  </nav>
</footer>

<style lang="less">
  @import (less) '@spotify-internal/encore-foundation/web/tokens.css';
  @import (reference) '../../less/variables';

  footer {
    font-size: @masthead-font-size-medium;
    font-family: @masthead-font-family-default;
    font-weight: @masthead-font-weight-normal;
    background: var(--solid-black-0);
    padding: 50px 0 20px;

    @media (min-width: @breakpoint-tablet) {
      padding: 80px 0 50px;
    }
  }

  :lang(ar) {
    font-family: @masthead-font-family-default-ar !important;
    letter-spacing: 0 !important;
  }

  /* Language Urdu uses the same font and font fallbacks as Arabic. */
  :lang(ur) {
    font-family: @masthead-font-family-default-ar !important;
    letter-spacing: 0 !important;
  }

  :lang(he) {
    font-family: @masthead-font-family-default-hbr !important;
    letter-spacing: 0 !important;
  }

  :lang(ru) {
    font-family: @masthead-font-family-default-cyr !important;
    letter-spacing: 0 !important;
  }

  :lang(ko) {
    font-family: @masthead-font-family-default-han !important;
  }

  :lang(el) {
    font-family: @masthead-font-family-default-el !important;
  }

  :lang(hi),
  :lang(ne) {
    font-family: @masthead-font-family-default-deva !important;
  }

  nav {
    margin: 0 auto;
    width: 100%;

    @media (min-width: @breakpoint-mobile) {
      width: @page-width-mobile;
    }

    @media (min-width: @breakpoint-tablet) {
      width: @page-width-tablet;
    }

    @media (min-width: @breakpoint-desktop) {
      width: @page-width-desktop;
    }
  }

  .mh-brand {
    display: block;
    box-sizing: border-box;
    padding: 0 @masthead-gutter-width;

    @media (min-width: @breakpoint-mobile) {
      width: 100% / 6;
    }

    @media (min-width: @breakpoint-tablet) {
      min-height: 346px;
    }
  }

  .mh-top-links {
    display: flex;
    flex-direction: column;

    @media (min-width: @breakpoint-mobile) {
      flex-direction: row;
    }
  }

  .mh-social-icons {
    margin: 120px @masthead-gutter-width @masthead-gutter-width;
  }

  .mh-country {
    margin: 0 @masthead-gutter-width;
    display: flex;
    justify-content: flex-end;
  }

  .mh-company-info {
    margin: 0 @masthead-gutter-width;
    display: flex;
  }

  .mh-bottom-links {
    display: flex;
  }

  @media (min-width: @breakpoint-tablet) {
    nav {
      display: flex;
      flex-wrap: wrap;
    }

    .mh-top-links,
    .mh-brand {
      flex: 0 0 auto;
    }

    .mh-brand {
      width: 100% / 6;
    }

    .mh-top-links {
      width: 50%;
    }

    .mh-social-icons {
      margin: 0 @masthead-gutter-width 0 auto;
    }

    .mh-country,
    .mh-bottom-links {
      width: 100%;
    }
  }
</style>

<script>
  import Brand from '../shared/Brand.html';
  import FooterTopLinks from './components/FooterTopLinks.html';
  import SocialLinks from './components/SocialLinks.html';
  import Country from './components/Country.html';
  import FooterBottomLinks from './components/FooterBottomLinks.html';
  import CopyrightNotice from './components/CopyrightNotice.html';
  import CompanyInformation from './components/CompanyInformation.html';
  import { logClickEventFooter } from '../../lib/logClickEvent';

  export let brand;
  export let topLinkGroups;
  export let socialLinks;
  export let country;
  export let colorClassNames;
  export let bottomLinks;
  export let copyrightNotice;
  export let companyInformation;

  $: colorClassNames = Object.assign(
    {
      primary: 'mh-footer-primary',
      secondary: 'mh-footer-secondary',
      hover: 'mh-footer-hover',
    },
    colorClassNames,
  );
</script>
